module.exports = __webpack_public_path__ + "static/UAmobSlide7-e9e0a25e2016bdff19f3669b30299429.jpg";